<template>
    <div class="select-wrapper">
        <slot></slot>
        <svg height="22" width="22" class="t-icon chevron-down svg-pointer"></svg>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cdn_url: window.APP_CONFIG.CDN_URL
        }
    }
}
</script>

<style lang="scss">
.select-wrapper {
    .svg-pointer {
        z-index: 2;
        position: absolute;
        pointer-events: none;
        right: 0; 
        height: 100%;
        top: auto;
        background-color: var(--sd-primary-normal);
    }
}
</style>
